
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "id": "input-5",
    "style": "enable-background:new 0 0 32 32;",
    "version": "1.1",
    "viewBox": "0 0 32 32",
    "xml:space": "preserve",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
  },
  "children": [
    {
      "tag": "g",
      "children": [
        {
          "tag": "g",
          "children": [
            {
              "tag": "path",
              "attrsMap": {
                "d": "M30,32H10v-2h20V2H2v20H0V2c0-1.103,0.897-2,2-2h28c1.103,0,2,0.897,2,2v28C32,31.103,31.103,32,30,32z"
              }
            }
          ]
        },
        {
          "tag": "g",
          "children": [
            {
              "tag": "rect",
              "attrsMap": {
                "height": "2",
                "transform": "matrix(0.7071 -0.7071 0.7071 0.7071 -11.1274 14.136)",
                "width": "29.698",
                "x": "-3.349",
                "y": "19.5"
              }
            }
          ]
        },
        {
          "tag": "g",
          "children": [
            {
              "tag": "path",
              "attrsMap": {
                "d": "M23,19h-2v-8h-8V9h9c0.552,0,1,0.448,1,1V19z"
              }
            }
          ]
        }
      ]
    }
  ]
})
    }
  